/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateContactDataRequest } from "../types/UpdateContactDataRequest.ts";

export const updateContactDataRequestSchema = z.object({
  celPhone: z
    .string()
    .describe("Número de celular da pessoa. Opcional.")
    .nullish(),
  homePhone: z
    .string()
    .describe("Número de telefone residencial da pessoa. Opcional.")
    .nullish(),
  workPhone: z
    .string()
    .describe("Número de telefone comercial da pessoa. Opcional.")
    .nullish(),
  fax: z.string().describe("Número de fax da pessoa. Opcional.").nullish(),
  isWhatsapp: z
    .boolean()
    .describe(
      "Indica se o número de celular cadastrado possui WhatsApp. Opcional.",
    )
    .nullish(),
  receiveSms: z
    .boolean()
    .describe(
      "Define se a pessoa aceita receber notificações por SMS. Opcional.",
    )
    .nullish(),
  receiveMarketing: z
    .boolean()
    .describe(
      "Define se a pessoa aceita receber comunicações de marketing. Opcional.",
    )
    .nullish(),
  site: z
    .string()
    .describe("URL do site pessoal ou profissional da pessoa. Opcional.")
    .nullish(),
}) as unknown as ToZod<UpdateContactDataRequest>;
